export default "__VITE_ASSET__xPCymNkd__"